import { memo } from "react";
import { useTypedSelector } from "hooks";
import useActions from "features/onboarding/useActions";
import { selectIsApplicationsLoading } from "features/onboarding/selectors";
import { OnboardingApplicationStatus } from "consts/onboarding";
import { ConfirmatableDialog } from "ui/molecules/Dialog";
import { Action, useApplicationTableResourceContext } from "../ApplicationTableResourceProvider";

const MarkIdleApplication = () => {
    const { context, onClose } = useApplicationTableResourceContext();
    const isApplicationsLoading = useTypedSelector(selectIsApplicationsLoading);
    const { updateApplication } = useActions();

    const handleMarkInProgressApplication = () => {
        const [request] = updateApplication({
            userId: context!.row.userId,
            status: OnboardingApplicationStatus.Idle
        });

        return request
            .then(onClose);
    };

    const content = {
        dialogContent: [
            `Are you sure you want mark as "IDLE" the application ${context?.row.pki}?`
        ],
        actionContent: 'Yes'
    };

    return (
        <ConfirmatableDialog
            isProcessing={isApplicationsLoading}
            open={Object.is(context?.action, Action.IdleApplication)}
            checkPredicate={() => false}
            content={[
                content,
                content
            ]}
            onConfirm={handleMarkInProgressApplication}
            onCancel={onClose}
        />
    );
};

export default memo(MarkIdleApplication);
